









































import { defineComponent, inject } from '@vue/composition-api'
import UserAvatar from '@/components/UserAvatar.vue'
import PaymentStatusBadge from '@/components/PaymentStatusBadge.vue'
import moment from 'moment'
import { toDateString } from '@/lib/utils'
import { useMutation } from '@vue/apollo-composable'
import deleteAuthMutation from '@/lib/graphql/deleteAuth.mutation.gql'
import userQuery from '@/lib/graphql/user.query.gql'

export default defineComponent({
  components: {
    UserAvatar,
    PaymentStatusBadge
  },

  setup(_, { root }) {
    // eslint-disable-next-line
    const { data: user, loading } = inject('user') as any

    const toDate = moment

    const columns = [
      {
        title: 'provider',
        dataIndex: 'provider'
      },
      {
        title: 'uid',
        dataIndex: 'uid'
      },
      {
        title: 'created at',
        dataIndex: 'inserted_at',
        scopedSlots: { customRender: 'date' }
      },
      {
        title: '',
        key: 'action',
        scopedSlots: { customRender: 'action' }
      }
    ]

    const { mutate: deleteAuthMut, onError } = useMutation(
      deleteAuthMutation,
      () => ({
        // eslint-disable-next-line
        update: (cache: any, { data: newData }) => {
          if (!newData.delete_authorizations.returning) {
            return
          }
          // eslint-disable-next-line
          const data: any = cache.readQuery({
            query: userQuery,
            variables: { id: user.value.id }
          })

          data.users_by_pk.authorizations = data.users_by_pk.authorizations.filter(
            (d: { id: string }) =>
              d.id !== newData.delete_authorizations.returning[0].id
          )

          cache.writeQuery({
            query: userQuery,
            variables: { id: user.value.id },
            data
          })
        }
      })
    )

    const deleteAuth = (id: string) => {
      // eslint-disable-next-line
      // @ts-ignore
      deleteAuthMut({ id })
    }

    // eslint-disable-next-line
    onError((err: any) => {
      console.error(err)
      root?.$message.error('Something went wrong')
    })

    return {
      loading,
      toDate,
      user,
      toDateString,
      columns,
      deleteAuth
    }
  }
})
